<p-dropdown
  *ngIf="!isTablet && !isMobileDevice"
  [options]="options"
  [(ngModel)]="value"
  [filter]="filter"
  [inputId]="id"
  [disabled]="disabled"
  [placeholder]="getPlaceholder(value, placeholder)"
  [scrollHeight]="scrollHeight"
  (onChange)="onSelectChange($event)"
  (onFocus)="onFocus($event)"
  (onBlur)="onBlur($event)"
  [disableItems]="disableItems"
  [class.validation-error]="validationError && !isFocused"
  tmoDropDown
  (onInputEvent)="value = $event"
  [prefix]="prefix"
  dropdownIcon="fa fa-caret-down"
>
  <ng-container *ngIf="showIcon">
    <ng-template let-selected pTemplate="selectedItem">
      <span>
        <i
          *ngIf="selected?.icon"
          class="t-icon t-icon-card-{{ selected?.icon?.toLowerCase() }} m-r-sm"
        ></i>
        {{ selected.label }}
      </span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <span>
        <i *ngIf="item?.icon" class="t-icon t-icon-card-{{ item?.icon?.toLowerCase() }} m-r-sm"></i>
        {{ item.label }}
      </span>
    </ng-template>
  </ng-container>
  <ng-template *ngIf="disableItems" let-option pTemplate="item">
    <div>
      <div
        (click)="onClick(option.disabled, $event)"
        [ngStyle]="option.disabled ? { color: '#ccc', cursor: 'default' } : ''"
      >
        {{ option.label }}
      </div>
    </div>
  </ng-template>
</p-dropdown>

<select
  *ngIf="isTablet || isMobileDevice"
  style="background: #f0f0f0; height: 40px; width: 100%"
  [(ngModel)]="value"
  id="{{ id }}"
  [disabled]="disabled"
  (change)="newonSelectChange($event, options[$event.target.selectedIndex], $event.target.selectedIndex)"
  (blur)="onBlur($event)"
  (focus)="onFocus($event)"
  [class.validation-error]="validationError && !isFocused">
  <option selected *ngIf="placeholder && options?.length === 0">{{ placeholder }}</option>
  <ng-container *ngFor="let option of options; let idx = index">
    <option selected *ngIf="placeholder && idx === 0" hidden disabled>{{ placeholder }}</option>
    <option [ngValue]="option.value">{{ option.label }}</option>
  </ng-container>
</select>
<p *ngIf="validationError && !isFocused" class="small error-label">{{ validationErrorMsg }}</p>
